import styled from '@emotion/styled'
import { faInbox } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const EmptyContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px 24px;
    text-align: center;
`

const EmptyIcon = styled.div`
    color: #9ca3af;
`

const EmptyTitle = styled.h4`
    font-size: 1.8rem;
    font-weight: 600;
    color: #4b5563;
    margin: 0 0 8px 0;
`

const EmptyDescription = styled.p`
    font-size: 1.4rem;
    color: #6b7280;
    margin: 0;
    max-width: 300px;
`

interface EmptyStateProps {
    title?: string
    description?: string
    icon?: React.ReactNode
}

const EmptyState = ({
    title = 'Aucune donnée',
    description = "Il n'y a aucune information à afficher pour le moment.",
    icon,
}: EmptyStateProps) => {
    return (
        <EmptyContainer>
            <EmptyIcon>{icon || <FontAwesomeIcon icon={faInbox} />}</EmptyIcon>
            <EmptyTitle>{title}</EmptyTitle>
            <EmptyDescription>{description}</EmptyDescription>
        </EmptyContainer>
    )
}

export default EmptyState
